import {
  orderAtom,
  orderIdAtom,
  selectedProductsAtom,
  selectedThemeAtom,
  themesArrayAtom,
  mappedProductsAtom,
  currentProductIdAtom,
  caseAtom,
  caseFieldsAtom,
  layoutAtom,
} from 'atoms'
import { productTabAtom } from '@/atoms/_printPackageAtoms'
import { caseImagesAtom } from '@/atoms/caseImageAtoms'
import { useResetRecoilState } from 'recoil'

export const useResetOrderAndCaseAtoms = () => {
  const resetSelectedProducts = useResetRecoilState(selectedProductsAtom)
  const resetSelectedTheme = useResetRecoilState(selectedThemeAtom)
  const resetThemesArray = useResetRecoilState(themesArrayAtom)
  const resetMappedProducts = useResetRecoilState(mappedProductsAtom)
  const resetCurrentProductId = useResetRecoilState(currentProductIdAtom)
  const resetCase = useResetRecoilState(caseAtom)
  const resetCaseImages = useResetRecoilState(caseImagesAtom)
  const resetOrder = useResetRecoilState(orderAtom)
  const resetOrderId = useResetRecoilState(orderIdAtom)
  const resetCaseFieldsAtom = useResetRecoilState(caseFieldsAtom)
  const resetProductTab = useResetRecoilState(productTabAtom)
  const resetLayout = useResetRecoilState(layoutAtom)

  return (skipCaseReset) => {
    resetSelectedProducts()
    resetSelectedTheme()
    resetThemesArray()
    resetMappedProducts()
    resetCurrentProductId()
    resetProductTab()
    resetLayout()
    if (!skipCaseReset) {
      resetCase()
      resetCaseImages()
      resetCaseFieldsAtom()
    }
    resetOrder()
    resetOrderId()
  }
}

export default useResetOrderAndCaseAtoms
